export default "__VITE_ASSET__9a8edeb7__"